import React, { useState, useEffect, useMemo } from 'react';
import { MessageBox, Tree, message } from 'kenshin';

const WorkPackageModal = (props) => {
  const { visible, onCancel, onOk, treeData, type, sourceId } = props;
  const [selectedKeys, setSelectedKeys] = useState([]);

  useEffect(() => {
    if (visible) {
      setSelectedKeys([]);
    }
  }, [visible]);

  const handleOk = () => {
    if (selectedKeys.length === 0) {
      message.warn('请选择目标节点');
      return;
    }
    onOk(selectedKeys[0]);
  };

  const loop = (data, level = 1) => {
    if (!Array.isArray(data)) return [];
    const result = [];
    data.forEach((item) => {
      const key = item.proServCatgId || item.key;
      // 禁用或隐藏自己（及其子树，如果需要防止移入子节点）
      // 这里根据需求，自己禁用或不显示。通常移动到自己或子代是无效的。
      // 简单起见，如果key等于sourceId，则禁用（或者跳过不渲染）
      // 用户要求：自己本身也要禁用或者不显示出来
      if (key === sourceId) {
        // 选择不渲染自己
        return;
      }

      let disabled = false;
      const hasChildren = item.childList && item.childList.length > 0;

      if (type === 'move') {
        // 移动：
        // 1. 叶子节点要禁用 (leaf nodes disabled)
        // 2. 最多支持3层树结构 (level >= 3 disabled)
        if (!hasChildren) {
          disabled = true;
        }
        if (level >= 3) {
          disabled = true;
        }
      } else if (type === 'merge') {
        // 合并：只能选择叶子节点
        if (hasChildren) {
          disabled = true;
        }
      }

      const title = `${item.servCatgCode || ''} ${item.servCatgName}`;

      result.push({
        title,
        key,
        disabled,
        children: item.childList ? loop(item.childList, level + 1) : [],
      });
    });
    return result;
  };

  const filteredTreeData = useMemo(() => {
    if (!treeData || !sourceId) return [];
    const checkContains = (item) => {
      const key = item.proServCatgId || item.key;
      if (key === sourceId) return true;
      if (item.childList && item.childList.length > 0) {
        return item.childList.some(checkContains);
      }
      return false;
    };
    return treeData.filter(checkContains);
  }, [treeData, sourceId]);

  const treeNodes = loop(filteredTreeData);

  return (
    <MessageBox
      title={type === 'move' ? '移动工作包' : '合并工作包'}
      visible={visible}
      onOk={handleOk}
      onCancel={onCancel}
      destroyOnClose
    >
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {treeNodes.length > 0 ? (
          <Tree
            treeData={treeNodes}
            selectedKeys={selectedKeys}
            onSelect={(keys) => setSelectedKeys(keys)}
            defaultExpandAll
            blockNode
          />
        ) : (
          <div>暂无数据</div>
        )}
      </div>
    </MessageBox>
  );
};

export default WorkPackageModal;
